import styled from "styled-components";

const MyDiv = styled.div`

.chakra-datepicker {
  z-index: 9999;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0px 10px 30px rgba(0,0,0,0.08);
}

/* MAIN CALENDAR */
.react-datepicker {
  border: none;
  font-family: "Inter", sans-serif;
  border-radius: 18px;
  padding: 12px;
}

/* HEADER */
.react-datepicker__header {
  background: #FFFFFF;
  border-bottom: none;
  padding-top: 12px;
}

/* MONTH TEXT */
.react-datepicker__current-month {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 12px;
}

/* NAVIGATION */
.react-datepicker__navigation {
  top: 16px;
}

.react-datepicker__navigation-icon::before {
  border-color: #6B7280;
}

/* DROPDOWNS */
.react-datepicker select {
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

/* WEEK HEADER */
.react-datepicker__day-name {
  width: 40px;
  line-height: 40px;
  color: #9CA3AF;
  font-size: 12px;
  font-weight: 600;
}

/* DAYS */
.react-datepicker__day {
  width: 40px;
  line-height: 40px;
  border-radius: 10px;
  margin: 2px;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

/* HOVER */
.react-datepicker__day:hover {
  background: #EEF2FF;
}

/* TODAY */
.react-datepicker__day--today {
  background: #EEF2FF;
  color: #4F46E5;
}

/* SELECTED */
.react-datepicker__day--selected,
.react-datepicker__day--in-range,
.react-datepicker__day--keyboard-selected {
  background: #4F46E5 !important;
  color: #FFFFFF !important;
}

/* DISABLED */
.react-datepicker__day--disabled {
  opacity: 0.4;
}

`;

export default MyDiv;